export const SEND_AUTH_EMAIL = 'SEND_AUTH_EMAIL';
export const SEND_AUTH_EMAIL_SUCCESS = 'SEND_AUTH_EMAIL_SUCCESS';
export const SEND_AUTH_EMAIL_ERROR = 'SEND_AUTH_EMAIL_ERROR';
